import React, { Component } from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import MessageProvider from "../classes/MessageProvider";
import MessageBox from "../comp/MessageBox";

interface Preventable {
    preventDefault: () => void
}

export default class LoginPage extends Component<ServiceCollectionParam, {}> {

    messages = new MessageProvider(this.setState.bind(this));

    username = React.createRef<HTMLInputElement>();
    password = React.createRef<HTMLInputElement>();

    async login(e: Preventable) {
        e.preventDefault();

        let auth = this.props.services.auth;

        const username = this.username.current?.value || ''
        const password = this.password.current?.value || ''

        let credentials;
        try {
            credentials = await this.props.services.dao.login(username, password);
        } catch (e) {
            this.messages.error('Vale kasutajanimi või salasõna');
            return;
        }

        auth.setLoginInfo(credentials);

        const settings = await this.props.services.dao.getUiSettings(username);
        this.props.services.uiSettings.load(settings);

        this.props.services.history.push('/results/' + credentials.userName);
    }

    render() {
        return (
            <form onSubmit={ e => this.login(e) }>

                <div className="row justify-content-center pt-5">
                    <div className="col-12 col-md-10 col-xl-8 mb-5">
                        <MessageBox messages={ this.messages.getMessages() } />
                    </div>

                    <div className="w-100"></div>

                    <div className="col-auto login-form">

                        <label htmlFor="username">Kasutajanimi</label>
                        <input ref={this.username}
                               type="text"
                               className="form-control mb-3" id="username" />


                        <label htmlFor="inputPass">Salasõna</label>
                        <input ref={this.password}
                               type="password"
                               className="form-control mb-4"
                               id="inputPass" />

                        <div className="d-flex justify-content-end">
                            <button type="submit"
                                    className="btn btn-primary w-50">Logi sisse</button>
                        </div>
                    </div>
                </div>
            </form>);
    }
}
